import * as React from "react";
import { SelectStyles } from "soprasteria-ui-library";
import { useFormContext } from 'react-hook-form';
import Select, { createFilter, ValueType } from 'react-select';
import { IPatientTreatment } from "../../../models/IPatientTreatment";

interface IOption {
    value: string;
    label: string;
    selected?: boolean;
}

interface IEmergencyTreatmentDropdown {
    treatments: IPatientTreatment[];
    defaultValue?: string;
    labelCol?: number;
    inputCol?: number;
    name: string;
    required?: boolean;
}

export const EmergencyTreatmentsDropdown: React.FunctionComponent<IEmergencyTreatmentDropdown> = ({ treatments, defaultValue, labelCol, inputCol, name, required }) => {

    const { register, setValue, errors } = useFormContext();
    const [selectedValue, setSelectedValue] = React.useState<IOption>();
    const [treatmentsOptions, setTreatmentsOptions] = React.useState<IOption[]>([])

    React.useEffect(() => {
        register({ name: name }, { required: required });

        const options = treatments.map<IOption>((treatment) => {
            return {
                value: treatment.treatmentCodeId.toString(),
                label: `${treatment.code} - ${treatment.description}`,
                selected: treatment.treatmentCodeId.toString() == defaultValue
            }
        });

        const initalValue = options.find((option) => { return option.selected == true });
        if (initalValue) {
            setValue(name, initalValue.value);
            setSelectedValue(initalValue);
        }
        setTreatmentsOptions(options);
    }, [treatments, required]);

    const onChange = (selectedOption: any | null) => {
        if (selectedOption) {
            setValue(name, selectedOption.value);
            setSelectedValue(selectedOption)
        }
        else {
            setValue(name, undefined);
            setSelectedValue(undefined)
        }
    }

    return (
        <div className="form-group row">
            <label className={`col-${labelCol ?? 4} col-form-label`}>Åtgärdskod:{required ? "*" : ""}</label>
            <div className={`col-${inputCol ?? 8}`}>
                <Select
                    placeholder={"Välj åtgärd"}
                    filterOption={createFilter({ ignoreAccents: false })}
                    styles={SelectStyles}
                    options={treatmentsOptions}
                    isOptionSelected={(option: IOption) => option.selected === true}
                    value={selectedValue}
                    onChange={(selectedOption: any) => onChange(selectedOption)}
                />

                <span className="text-danger">{errors ? [name] && (errors[name] as any)?.type === "required" && "Välj en åtgärdskod" : ""}</span>
            </div>
        </div>
    )
}